import { api } from "../../config/api";
import { appApi } from "./appApi";

export interface TermsSessionArgs {
  business_id: string;
  device_token: string;
  session_id: string;
}

export interface PendingTermsInfo {
  terms_id: number;
  terms_name?: string;
  terms_version?: string;
  platform_version?: string;
  start_date?: string;
  end_date?: string;
  is_active?: boolean;
  text?: string;
}

export interface TermsStatusCheckResponse {
  success?: boolean;
  accepted?: boolean;
  data?: {
    terms_info?:
      | PendingTermsInfo
      | {
          terms_accept?: Array<{
            terms_id?: number;
            terms_name?: string;
            business_id?: number;
            business_name?: string;
            country?: string;
            ip_address?: string;
            accepted_state?: boolean;
            accepted_date?: string;
            text?: string;
          }>;
        };
  };
  errors?: string[] | string;
  error_code?: string | null;
}

export interface AcceptTermsArgs extends TermsSessionArgs {
  terms_id: number;
  country: string;
  ip_address: string;
}

export interface AcceptTermsResponse {
  success?: boolean;
  data?: {
    business_info?: {
      terms_id?: number;
      terms_name?: string;
      business_name?: string;
      user_details?: string;
      terms_version?: string;
      platform_version?: string;
      start_date?: string;
      end_date?: string;
      country?: string;
      ip_address?: string;
      accepted_state?: boolean;
    };
  };
  errors?: string[] | string;
  error_code?: string | null;
}

function toRequestBusinessId(businessId: string): number | string {
  const trimmed = businessId.trim();
  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : trimmed;
}

export const termsApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getTermsStatusCheck: builder.query<TermsStatusCheckResponse, TermsSessionArgs>({
      query: (args) => ({
        url: api.urls.GET_TERMS_STATUS_CHECK,
        method: "POST",
        body: {
          business_id: toRequestBusinessId(args.business_id),
          device_token: args.device_token,
          session_id: args.session_id,
        },
      }),
      providesTags: ["TermsStatus"],
      keepUnusedDataFor: 300,
    }),
    acceptTerms: builder.mutation<AcceptTermsResponse, AcceptTermsArgs>({
      query: (args) => ({
        url: api.urls.CREATE_ACCEPTANCE_TERMS,
        method: "POST",
        body: {
          terms_id: args.terms_id,
          accepted_state: true,
          country: args.country,
          ip_address: args.ip_address,
          business_id: toRequestBusinessId(args.business_id),
          device_token: args.device_token,
          session_id: args.session_id,
        },
      }),
      invalidatesTags: ["TermsStatus"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetTermsStatusCheckQuery, useAcceptTermsMutation } = termsApi;
